export default {
      id: "lely-bg-point-usage",
      viewBox: "0 0 300 900",
      url: __webpack_public_path__ + "img/icons.50d286a4.svg#lely-bg-point",
      toString: function () {
        return this.url;
      }
    }